import gql from 'graphql-tag';

import { PUSH_NOTIFICATION_ENABLED } from 'constants/checklist';
import {
  DELIVERY_METHODS_AVAILABLE,
  DELIVERY_WEB,
  TOGGLE_NOTIFICATION_TYPES,
} from 'constants/notifications';
import { getGraphQLClient } from 'utilities/graphql';
import * as logger from 'utilities/loggerx';

import { updateChecklistItem } from '../actions/checklist';
import { successNotificationSettings } from '../actions/notification-settings';
import { removeNonRootScopedServiceWorkers } from '../utilities/notifications';

const UpdateNotifSettingsByDevlieryTypeMutation = gql`
  mutation updateNotificationSettingsByDeliveryType(
    $deliveryMethod: NotificationDeliveryType!,
    $deliveryValue: Boolean!) {
      updateNotificationSettingsByDeliveryType(
      deliveryMethod: $deliveryMethod,
      deliveryValue: $deliveryValue
    ) {
      ${TOGGLE_NOTIFICATION_TYPES.map(
        notifSetting => `${notifSetting} {
          ${DELIVERY_METHODS_AVAILABLE.join('\n')}
        }`
      ).join('\n\n')}
    }
  }
`;

export function reenableWebNotifications(reloadAfterSuccess) {
  return dispatch => {
    const gqlClient = getGraphQLClient();

    return gqlClient
      .mutate({
        mutation: UpdateNotifSettingsByDevlieryTypeMutation,
        variables: {
          deliveryMethod: DELIVERY_WEB,
          deliveryValue: true,
        },
        fetchPolicy: 'no-cache',
      })
      .then(async resp => {
        if (!resp.data) {
          logger.error(
            new Error('Unexpected response when enabling all web notifications')
          );
        }

        // we want to remove non root scoped service workers. These workers were
        // added due to a bug in the initial notifs release which cause double notifs
        await removeNonRootScopedServiceWorkers();

        dispatch(updateChecklistItem(PUSH_NOTIFICATION_ENABLED, true));
        dispatch(successNotificationSettings());

        if (reloadAfterSuccess) {
          window.location.reload();
        }
      })
      .catch(error => {
        logger.error(
          error,
          {
            message: `Error updating push notification settings`,
          },
          {
            team: logger.CREATE_TEAM,
          }
        );
      });
  };
}
